import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './aftercare.css';
import Lottie from 'lottie-react';
import star from '../../Assets/Star 2.png';
import frameAnimation from '../../Assets/Frame 51.json';

import star1 from '../../Assets/star1.png';
import star2 from '../../Assets/star2.png';
import star3 from '../../Assets/star3.png';
import star4 from '../../Assets/star4.png';
import star5 from '../../Assets/star5.png';

import GoogleReviews from '../googlereview/googlereview';

const AfterCare = () => {
  return (
    <div className='p-0 m-0 aftercarepage'>
      <Row>
        <Col xs={12} md={6} lg={3} style={{ position: 'relative' }}>
          <div>
            <img src={require('../../Assets/aftercare.png')} className='w-100' alt="Adorn Image" />
            {/* Adding the GIF in the middle */}
            <div className="gif-section">
      <div
        style={{
          position: 'absolute', 
          top: '70%', 
          left: '90%', 
          transform: 'translate(-50%, -50%)', // Centers the animation
          zIndex: 500, // Ensures it overlays other elements
          width: '150px', // Adjust size as needed
          height: '150px'
        }}
      >
        <Lottie 
          animationData={frameAnimation} 
          loop={true} // Enable looping, similar to a GIF
          style={{ width: '100%', height: '100%' }} // Make it responsive within the container
        />
      </div>
    </div>
          </div>
        </Col>

        <Col xs={12} md={6} lg={2}>
          <div className='aftercare-section'>
            <h2>TIPS</h2>
            <h1>Aftercare</h1>
          </div>
        </Col>

        <Col xs={12} md={6} lg={7}>
          <div className='text'>
            <div className="bullet-point">
              <img src={star} alt="Star Bullet" className="bullet-image" />
              <p>Do clean the area with saline spray 3 times a day after dry with tissue without moving the jewellery</p>
            </div>
        <div className="bullet-point">
          <img src={star} alt="Star Bullet" className="bullet-image" />
          <p>Don't use your hands to touch or twist the jewelry or area for the first 3 weeks</p>
        </div>
        <div className="bullet-point">
          <img src={star} alt="Star Bullet" className="bullet-image" />
          <p>Don't sleep on your piercings</p>
        </div>
        <div className="bullet-point">
          <img src={star} alt="Star Bullet" className="bullet-image" />
          <p>Do use a travel neck pillow to hold your ear away from touching the bed or head pillow</p>
        </div>
        <div className="bullet-point">
          <img src={star} alt="Star Bullet" className="bullet-image" />
          <p>Don't use any oils, alcohol, or chemicals to clean your piercing</p>
        </div>
        <div className="bullet-point">
          <img src={star} alt="Star Bullet" className="bullet-image" />
          <p>Don't try to change your jewelry unless it's healed</p>
        </div>
        <div className="bullet-point">
          <img src={star} alt="Star Bullet" className="bullet-image" />
          <p>Avoid swimming pool water or sea water for 10 to 15 days</p>
        </div>
        <div className="bullet-point">
          <img src={star} alt="Star Bullet" className="bullet-image" />
          <p>Always use titanium and surgical or real gold for the first piercing</p>
        </div>
        <div className="bullet-point">
          <img src={star} alt="Star Bullet" className="bullet-image" />
          <p>Speak to your piercer for more advice</p>
        </div>
        <div className="bullet-point">
          <img src={star} alt="Star Bullet" className="bullet-image" />
          <p>Stay healthy, eat well, and avoid stress</p>
        </div>
        </div>
      </Col>
    </Row>
    <Row>
    <Container fluid>
      <div className="testimonial-container">
      <div className="testimonial-track">
          <div className="testimonial-card">
          <img src={star1} alt="Star Bullet" className="bullet-image" />            
            <img src={star2} alt="Star Bullet" className="bullet-image" />
            <img src={star3} alt="Star Bullet" className="bullet-image" />
            <img src={star4} alt="Star Bullet" className="bullet-image" />
            <img src={star5} alt="Star Bullet" className="bullet-image" />
            <p>Very proffessional and good service did piercing for my 8 month old baby and husband very paitent and good service totally recommend</p>
            <p><strong>
            Anisha Bhatia</strong></p>
          </div>
          <div className="testimonial-card">
          <img src={star1} alt="Star Bullet" className="bullet-image" />            
            <img src={star2} alt="Star Bullet" className="bullet-image" />
            <img src={star3} alt="Star Bullet" className="bullet-image" />
            <img src={star4} alt="Star Bullet" className="bullet-image" />
            <img src={star5} alt="Star Bullet" className="bullet-image" />
            <p>I did a piercing with Mr Ali it was a smooth process without any pain. I highly recommend this place.</p>
            <p><strong>sharon mendez</strong></p>
          </div>
          <div className="testimonial-card">
          <img src={star1} alt="Star Bullet" className="bullet-image" />            
            <img src={star2} alt="Star Bullet" className="bullet-image" />
            <img src={star3} alt="Star Bullet" className="bullet-image" />
            <img src={star4} alt="Star Bullet" className="bullet-image" />
            <img src={star5} alt="Star Bullet" className="bullet-image" />
            <p>Thank you for amazing home service Resmi . I really like it</p>
            <p><strong>mehdjouba Baghdadi</strong></p>
          </div>
          <div className="testimonial-card">
          <img src={star1} alt="Star Bullet" className="bullet-image" />            
            <img src={star2} alt="Star Bullet" className="bullet-image" />
            <img src={star3} alt="Star Bullet" className="bullet-image" />
            <img src={star4} alt="Star Bullet" className="bullet-image" />
            <img src={star5} alt="Star Bullet" className="bullet-image" />
            <p>Very excellent home service, Resmi. S. Nair was very friendly, efficient and fast, it did not take long and I was very happy. Thank you.</p>
            <p><strong>جود جود</strong></p>
          </div>
          {/* Repeat testimonials to create smooth loop */}
          <div className="testimonial-card">
          <img src={star1} alt="Star Bullet" className="bullet-image" />            
            <img src={star2} alt="Star Bullet" className="bullet-image" />
            <img src={star3} alt="Star Bullet" className="bullet-image" />
            <img src={star4} alt="Star Bullet" className="bullet-image" />
            <img src={star5} alt="Star Bullet" className="bullet-image" />
            <p>It was a home service for my daughter. Everything went smoothly and quickly no pain, no drama 🤗 Excellent work!</p>
            <p><strong>
            Iman Hijazi Cheaib</strong></p>
          </div>
          <div className="testimonial-card">
          <img src={star1} alt="Star Bullet" className="bullet-image" />            
            <img src={star2} alt="Star Bullet" className="bullet-image" />
            <img src={star3} alt="Star Bullet" className="bullet-image" />
            <img src={star4} alt="Star Bullet" className="bullet-image" />
            <img src={star5} alt="Star Bullet" className="bullet-image" />
            <p>Excellent. Highly highly recommend. So convenient as they come to the house and have tons of piercing options. 👌👌</p>
            <p><strong>Michele Cullen</strong></p>
          </div>
          <div className="testimonial-card">
          <img src={star1} alt="Star Bullet" className="bullet-image" />            
            <img src={star2} alt="Star Bullet" className="bullet-image" />
            <img src={star3} alt="Star Bullet" className="bullet-image" />
            <img src={star4} alt="Star Bullet" className="bullet-image" />
            <img src={star5} alt="Star Bullet" className="bullet-image" />
            <p>Ali’s is the best and i didn’t feel any pain with an affordable price , im happy and satisfied 😁</p>
            <p><strong>Muneera Alshammari</strong></p>
          </div>
          <div className="testimonial-card">
            <img src={star1} alt="Star Bullet" className="bullet-image" />            
            <img src={star2} alt="Star Bullet" className="bullet-image" />
            <img src={star3} alt="Star Bullet" className="bullet-image" />
            <img src={star4} alt="Star Bullet" className="bullet-image" />
            <img src={star5} alt="Star Bullet" className="bullet-image" />
            <p>Loved the service by Reshmi. Did 3 piercings. Absolute professional</p>
            <p><strong>Cigy John</strong></p>
          </div>
        </div>
      </div>
    </Container>
    
    </Row>
    <br/>
  </div>

  );
};

export default AfterCare;
